import { SelectedWarehouse } from "@gtsanders/Store/Pages/CheckoutReviewAndSubmit/ShipmentBranchWarehouseReducer";
import { ShipBranchWarehouses } from "@gtsanders/Store/Pages/CheckoutReviewAndSubmit/ShipmentBranchWarehousesState";
import { ApiParameter, get, request } from "@insite/client-framework/Services/ApiService";

export interface LoadShipBranchWarehouseParameter extends ApiParameter{
}

export interface ShipBranchWarehousesResult {
    apiParameter: LoadShipBranchWarehouseParameter;
    apiResult: (ShipBranchWarehouses | null)[];
    shipBranchWarehouses: ShipBranchWarehouses[];
    isLoading: boolean;
    shipBranchWarehousesLoaded: boolean;   
    selectedWarehouse: SelectedWarehouse; 
}

const shipBranchWarehousesUrl = "/api/AllWhse/GetAllWhse";

export function getShipBranchWarehouses() {
    return get<(ShipBranchWarehouses | null)[]>(shipBranchWarehousesUrl, {} as LoadShipBranchWarehouseParameter);
}
